<template>
  <data-loader>
    <page-layout>
      <template #header>
        <simulation-header :title="simulation.name"></simulation-header>
      </template>
      <div
        class="simulation-page-content"
        v-html="html"
      >
      </div>
      <template #footer>
        <page-footer
          button-text="Submit"
          @next-button-clicked="handleSubmit"
        ></page-footer>
      </template>
    </page-layout>
  </data-loader>
</template>

<script>
import WuxSimulationsMixin from '@/mixins/wux-simulations';
import PageLayout from '@components/sims/single-section-sim/PageLayout.vue';
import SimulationHeader from '@components/sims/single-section-sim/SimulationHeader.vue';
import PageFooter from '@components/sims/single-section-sim/PageFooter.vue';
import DataLoader from '@/components/sims/DataLoader.vue';

export default {
  components: {
    PageLayout,
    PageFooter,
    SimulationHeader,
    DataLoader,
  },
  mixins: [WuxSimulationsMixin],
  computed: {
    html() {
      return this.simConfig?.endHtml || '';
    },
  },
  methods: {
    handleSubmit() {
      const simulationCategoryState = this.categoryStates[this.simulation.id];

      if (simulationCategoryState?.categoryStatusId !== this.completedStatus.id) {
        this.setCategoryState(this.simulation, this.completedStatus);
      }

      if (this.isMultiSectionSimulation) {
        this.$router.push({
          name: 'sims#performance',
          params: {
            simId: this.simId,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.simulation-page-content {
  font-size: 1.25rem;
  padding: 1.25rem;

  h1, h2, h3, h4, h5, h6 {
    font-size: 1.25rem;
  }
}
</style>
